<template>
  <div>
    <pg-mainshell :h1Title="h1Title">
      <el-container>
        <el-aside>
          <ir-slider>
            <pg-navmenu :datalist="datalist" @order="getOrder" v-if="datalistLoad"></pg-navmenu>
          </ir-slider>
        </el-aside>
        <el-main>
          <div class="border-left">
            <h2>用户权限</h2>
            <div>
              <el-table :data="tableInfo.tableData" :height="tableInfo.height" style="width: 100%" stripe v-if="tableInfo.tableData.length>0">
                <el-table-column prop="chName" label="名称" width="">
                </el-table-column>
                <el-table-column prop="permission" label="权限" width="">
                  <template slot-scope="scope">
                    <el-checkbox :value="scope.row.switchStatus===0" @change="handlePermissionChange(scope.$index, scope.row)" :disabled="scope.row.type === 1 || constant.getUserType()===1"></el-checkbox>
                  </template>
                </el-table-column>
              </el-table>
              <el-divider></el-divider>
              <div class="block">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.currentPage"
                :page-sizes="pagination.pagesizes" :page-size="pagination.pagesize" layout="total, sizes, prev, pager, next, jumper"
                :total="this.tableInfo.typeTableData.length">
                </el-pagination>
              </div>
            </div>
          </div>
        </el-main>
      </el-container>
    </pg-mainshell>
  </div>
</template>

<script>
import PgMainshell from '../../components/PgMainShell'
import IrSlider from '../../components/IrSlider'
import PgNavmenu from '../../components/PgNavMenu'
// import store from '../../store/index'
import constant from '../../utils/constant'

import typesvg from '../../assets/img/type.svg'

export default {
  data () {
    return {
      h1Title: '用户权限',
      order: '',
      orderChange: false,
      constant: constant,
      datalist: [],
      datalistLoad: false,
      tableInfo: {
        tableData: [],
        height: '',
        alltableData: [],
        typeTableData: [],
        type: 1
      },
      currentPage: 1,
      pagesizes: [10],
      pagesize: 10,
      pagination: {
        currentPage: 1,
        pagesizes: [10],
        pagesize: 10
      }
    }
  },
  created: function () {
    this.initListData()
    this.tableInfo.height = parseInt(window.innerHeight) - 90 - 42 - 35 - 37 - 24 - 30 - 30 - 25 - 24 - 100 + 'px'
    // 90头部  42-35内边距  37的h1 24的bottom  内容上下pading30 小标题25下24  100翻页
  },
  methods: {
    initListData () {
      this.getUserRoleTypeListApi()
      this.getUserRoleListApi(1)
    },
    getUserRoleTypeListApi () {
      let that = this
      this.$api.userPermission.userRoleTypeListApi()
        .then(function (res) {
          that.initMenuList(res.data.data)
        })
        .catch(function (err) {
          console.log(err)
          constant.giveMessage('Error！', 'error')
        })
    },
    initMenuList (data) {
      this.datalist = [{
        name: '接口文档',
        index: '0',
        img: typesvg,
        list: [{
          name: '接口类型',
          entityId: '0-0',
          apiMenu: []
        }]
      }]
      data.forEach(child => {
        let tmp = {
          name: child.chName,
          entityId: child.entityId,
          order: child.order
        }
        this.datalist[0].list[0].apiMenu.push(tmp)
      })
      this.datalistLoad = true
    },
    getOrder (order) {
      this.chanegUserRoleList(order)
    },
    async getUserRoleListApi (type) {
      let that = this
      await this.$api.userPermission.userRoleListApi()
        .then(function (res) {
          // 翻页专用数组,copy一份
          that.tableInfo.alltableData = res.data.data
          let nowAll = that.tableInfo.alltableData.filter((x, indexs) => x.type === that.tableInfo.type)
          nowAll.forEach((item) => {
            that.tableInfo.typeTableData.push(item)
          })
          let nowShow = nowAll.filter((x, indexs) => indexs >= 0 * that.pagination.pagesize && indexs < that.pagination.pagesize)
          nowShow.forEach((item) => {
            that.tableInfo.tableData.push(item)
          })
        })
        .catch(function (err) {
          console.log(err)
          constant.giveMessage('Error！', 'error')
        })
    },
    chanegUserRoleList (type) {
      this.tableInfo.tableData = []
      this.tableInfo.typeTableData = this.tableInfo.alltableData.filter((x, indexs) => x.type === type)
      this.tableInfo.type = type
      this.tableInfo.tableData = this.tableInfo.typeTableData.filter((x, indexs) => indexs >= 0 * this.pagination.pagesize && indexs < this.pagination.pagesize)
    },
    handleSizeChange (val) {
    },
    handleCurrentChange (val) {
      // 清空
      this.tableInfo.tableData.splice(0, this.tableInfo.tableData.length)
      this.pagination.currentPage = val
      let nowShow = this.tableInfo.typeTableData.filter((x, indexs) => indexs >= (parseInt(val) - 1) * this.pagination.pagesize && indexs < parseInt(val) * this.pagination.pagesize)

      nowShow.forEach((item) => {
        this.tableInfo.tableData.push(item)
      })
    },
    handlePermissionChange (index, row) {
      // 改变当前搜索的状态
      this.tableInfo.tableData[index].switchStatus = this.tableInfo.tableData[index].switchStatus === 0 ? null : 0

      // 获取total 所有有权限的
      let hasStatusList = this.tableInfo.alltableData.filter(x => x.switchStatus === 0)

      let hasStatusStr = ''
      for (let item in hasStatusList) {
        hasStatusStr = hasStatusStr + ',' + hasStatusList[item].entityId
      }
      if (hasStatusStr.length > 0) {
        hasStatusStr = hasStatusStr.substring(1)
      }

      this.$api.userPermission.setUserRoleApi(hasStatusStr)
        .then(function (res) {
        })
        .catch(function (err) {
          console.log(err)
          constant.giveMessage('Error！', 'error')
        })
    }
  },
  components: {
    PgMainshell,
    IrSlider,
    PgNavmenu
  }
}
</script>

<style scoped>
/* 撑开容器 */
.el-aside>div,
.el-main>div{
  height: 100%;
}
.el-container{
  width: 100%;
  height: 100%;
}
.el-container /deep/ .scroll{
  background: #fff;
}
  .el-aside {
    width: 250px !important;
    text-align: center;
    line-height: 33px;
    background: #f7f8f9;
    overflow-x: hidden;
  }
  .el-aside /deep/ .content>.el-menu{
    border-right: none;
  }
  .el-aside /deep/ .el-menu-item.is-active {
    padding-left: 80px !important;
  }
  .el-main{
    padding: 30px 0;
    line-height: initial;
    line-height: normal;
  }
  .border-left{
    border-left: 1px solid #E0E7EE;
    padding: 0 32px 0 46px;
  }
  .border-left>div{
    height: calc(100% - 49px);
  }
  .el-main h2{
    width: 100%;
    height: 25px;
    line-height: 25px;
    text-align: left;
    font: Bold 18px/21px Microsoft YaHei;
    letter-spacing: 0;
    color: #445870;
    opacity: 1;
    padding-bottom: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/containers/UserPermission/Index.vue